/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-21 09:51:50
 */
import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";
import { Carousel, message, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import "./index.less";
import axios from "@/axios/axios";
import * as actions from "@/store/actions";

const AllTrainPage: FC<any> = ({ history, storeData, setFrom }) => {
  // 推荐课程 列表
  const [recommandData, setRecommandData] = useState<any>([]);
  const getRecommend = async () => {
    const provinceCode = storeData.userInfo?.provinceCode;
    const { code, data, msg }: any = await axios.post(
      "/shop/front/ce/province/recommend/item/list",
      {}
    );
    if (code === 0) {
      setRecommandData(data);
    } else {
      message.error(msg);
    }
  };

  useEffect(() => {
    getRecommend();
  }, []);

  const jump = (data: any) => {
    history.push({ pathname: `/index/subject/${data.id}` });
  };

  return (
    <div className={"all-train-page"}>
      <div className="nav-container">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/index/home">首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>全员培训</Breadcrumb.Item>
        </Breadcrumb>
        <h5 style={{margin:"20px 0"}}>您所在的地区拥有以下项目，请您根据地区通知进行对应的学习。</h5>
      </div>
      <div className={"content-course"}>
        <div className={"content-course-box"}>
          <div className={"content-course-list"}>
            {recommandData.map((recommend: any, i: number) => (
              <div
                key={i}
                className={"content-course-item"}
                onClick={() => {
                  jump(recommend);
                }}
              >
                <div className={"item-img"}>
                  <img src={recommend.imageAllPath} alt="" />
                </div>
                <div className={"item-text"}>
                  <div className={"p-box"}>
                    <h3>{recommend.itemName}</h3>
                    <p>学分：{recommend.creditInfo}</p>
                    <p>项目负责人：{recommend.itemLeaderName}</p>
                    <p>编号：{recommend.itemCode}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(AllTrainPage);
